module.exports = __webpack_public_path__ + "static/media/dispur_college_qr.ba0e5256.png";